import { getMediaItemValidationSchema, type MediaItemFormType } from "@/modules/common/media/mediaFormTypes"
import { word } from "@/modules/core/utils/i18n"
import { ScoreDifficultyEnum, ScoreType } from "@modules/scores/scoreTypes"
import * as Yup from "yup"

export type ScoreFormikValueInputKey =
  | `valueDecimal`
  | `additionalValueDecimal`
  | `personalRecord`
  | `difficulty`
  | `note`
  | `noteAndMediaIsVisible`
  | `medias`
  | `scoreSetCompletions.${number}.score`
  | `scoreSetCompletions.${number}.scoreAdditional`
  | `scoreSetCompletions.${number}.difficulty`
  | `scoreSetCompletions.${number}.note`
  | `scoreSetCompletions.${number}.noteAndMediaIsVisible`
  | `scoreSetCompletions.${number}.medias`
  | `scoreSetCompletions.${number}.reps`
  | `scoreSetCompletions.${number}.tieBreaks`
  | `scoreSetCompletions.${number}.scoreSetCompletions`
  | `scoreSetCompletions.${number}.personalRecord`

export type ScoreSetCompletionFormikType = {
  id: string | null
  scoreSetConfigurationId: string
  displayOrder: number
  timeCapExceeded: boolean | null
  score: number | null
  scoreAdditional: number | null
  scoreType: ScoreType
  feedback: string | null
}

export type TieBreakFormikType = {
  time: number | null
  threshold: number
}

export type ScoreFormikType = {
  valueDecimal: number | null
  additionalValueDecimal: number | null
  timeCapExceeded: boolean | null
  difficulty: ScoreDifficultyEnum | null
  note: string
  noteAndMediaIsVisible: boolean
  medias: MediaItemFormType[]
  reps: number | null
  tieBreaks: TieBreakFormikType[] | null
  scoreSetCompletions: ScoreSetCompletionFormikType[]
  personalRecord: boolean
}

export function getScoreFormValidationSchema() {
  return Yup.object({
    valueDecimal: Yup.number().nullable(),
    additionalValueDecimal: Yup.number().nullable(),
    difficulty: Yup.mixed<ScoreDifficultyEnum>().required(word("global.form.required")),
    note: Yup.string().nullable(),
    noteAndMediaIsVisible: Yup.boolean(),
    medias: Yup.array()
      .of(getMediaItemValidationSchema())
      .test("", word("sessionForm.blocks.add_media.wrong_quantity_of_media"), (value) => {
        return (value && value.length <= 5) || !value
      }),
    reps: Yup.number().nullable(),
    scoreSetCompletions: Yup.array().of(getScoreSetCompletionValidationSchema()).nullable(),
    personalRecord: Yup.boolean(),
  })
}

export function getScoreSetCompletionValidationSchema() {
  return Yup.object({
    score: Yup.number()
      .positive(word("global.form.positive"))
      .required(word("global.form.required"))
      .nonNullable(word("global.form.required")),
    scoreAdditional: Yup.number().nullable(),
    timeCapExceeded: Yup.boolean().nullable(),
  })
}

export type CommentFormikType = {
  note?: string
  medias: MediaItemFormType[]
  noteAndMediaIsVisible: boolean
}

export const getCommentValidationSchema = () => {
  return Yup.object().shape({
    note: Yup.string().required(word("global.form.required")),
    noteAndMediaIsVisible: Yup.boolean(),
    medias: Yup.array()
      .of(getMediaItemValidationSchema())
      .test("", word("sessionForm.blocks.add_media.wrong_quantity_of_media"), (value) => {
        return (value && value.length <= 5) || !value
      }),
  })
}
